<template>
    <div>
        <!-- 筛选条 -->
        <el-form inline :model="formData" class="filter-bar">
            <el-form-item>
                <CustomInput label="游戏类型">
                    <SelectAll :options="options.game_classify" v-model="formData.game_classify" :multiple="false" placeholder="全部"/>
                </CustomInput>
            </el-form-item>
            <el-form-item>
                <CustomInput label="包体类型">
                    <SelectAll :options="options.package_type" v-model="formData.package_type" :multiple="false" placeholder="全部"/>
                </CustomInput>
            </el-form-item>
            <el-form-item>
                <CustomInput label="媒体渠道">
                    <SelectAll :options="options.plat" v-model="formData.plat_id" :multiple="false" placeholder="全部"/>
                </CustomInput>
            </el-form-item>
            <el-form-item>
                <CustomInput label="客户星级">
                    <el-input v-model="formData.star" placeholder="星级0-5" clearable size="mini" style="width:110px" @input="formData.star = (formData.star||'').replace(/[^0-5]/g,'').slice(0,1)" @keyup.enter.native="handleSearch"/>
                </CustomInput>
            </el-form-item>
            <el-form-item>
                <CustomInput label="集团名称">
                    <el-input v-model="formData.search" placeholder="集团名称模糊搜" clearable size="mini" style="width:180px" @keyup.enter.native="handleSearch"/>
                </CustomInput>
            </el-form-item>
            <el-form-item>
                <CustomInput label="ID">
                    <el-input v-model="formData.id" placeholder="记录ID精确查" clearable size="mini" style="width:120px" @input="formData.id = (formData.id||'').replace(/\D/g,'')" @keyup.enter.native="handleSearch"/>
                </CustomInput>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
                <el-button size="mini" @click="handleReset">重置</el-button>
            </el-form-item>
        </el-form>

        <!-- 工具条
             权限（2026-08-05 修正）：
               · edit_bloc_star（角色管理显示「添加/编辑星级」）→ 添加星级 / 批量改星级 / 表格行内「编辑」
               · import_bloc_star（「导入星级」）                → Excel 导入
             ⚠️ 原来整条工具条挂在 edit_bloc_star 上，导入按钮嵌在里面 → 只勾「导入星级」
                不勾「添加/编辑星级」的角色连导入按钮都被一起藏掉。两个权限必须各挂各的。 -->
        <div class="tool-bar mb10" v-if="canEditStar || canImportStar">
            <template v-if="canEditStar">
                <el-button type="primary" size="mini" @click="openAddDialog">添加星级</el-button>
                <el-button size="mini" :disabled="!multipleSelection.length" @click="openBatchDialog">批量改星级({{multipleSelection.length}})</el-button>
            </template>
            <el-upload
                v-if="canImportStar"
                :class="['dib', canEditStar ? 'ml10' : '']"
                :action="importUrl"
                name="file"
                :show-file-list="false"
                accept=".xlsx"
                :disabled="importing"
                :before-upload="handleBeforeImport"
                :on-success="handleImportSuccess"
                :on-error="handleImportError"
            >
                <el-button size="mini" plain :loading="importing" :disabled="importing">{{ importing ? '导入中…' : 'Excel 导入' }}</el-button>
            </el-upload>
            <el-tooltip placement="top" v-if="canImportStar">
                <div slot="content" style="line-height:1.7">
                    列序（首行为表头）：游戏类型 / 包体类型 / 渠道 / 集团名称 / 星级<br/>
                    · 游戏类型：IAA / IAP<br/>
                    · 包体类型：安卓应用 / 安卓快应用<br/>
                    · 渠道：OPPO / vivo / 华为ADS / 小米 / 荣耀（按系统渠道名匹配·不匹配跳过报告）<br/>
                    · 集团名称：直接入库（工单按此名匹配打星，须与工单集团名一致）<br/>
                    · 星级：一星~五星 或 0-5 数字（0=已评估最低优先）<br/>
                    每行 = (集团 × 渠道 × 包体 × 游戏类型) 一条星级，重复行后者覆盖前者
                </div>
                <span class="ml6 text-color-info">导入说明<i class="el-icon-question"/></span>
            </el-tooltip>
        </div>

        <jt-table
            v-loading="dataLoading"
            :data="dataList"
            stripe
            :header-cell-style="{background:'#e8eaec',color:'#333'}"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
            style="width:100%">
            <el-table-column type="selection" align="center" width="55"/>
            <el-table-column prop="id" label="ID" align="center" width="80"/>
            <el-table-column prop="bloc_name" label="集团名称" align="left" min-width="160" show-overflow-tooltip/>
            <el-table-column prop="game_classify_text" label="游戏类型" align="center" min-width="90"/>
            <el-table-column prop="package_type_text" label="包体类型" align="center" min-width="110" show-overflow-tooltip/>
            <el-table-column prop="plat_text" label="媒体渠道" align="center" min-width="100" show-overflow-tooltip/>
            <el-table-column label="客户星级" align="center" width="170" prop="star" sortable="custom">
                <template slot-scope="{ row }">
                    <el-rate v-model="row.star" disabled/>
                    <span class="text-color-info">({{row.star}})</span>
                </template>
            </el-table-column>
            <el-table-column prop="mtime" label="更新时间" align="center" min-width="130"/>
            <el-table-column label="操作" align="center" width="90" fixed="right" v-if="canEditStar">
                <template slot-scope="{ row }">
                    <el-button type="text" size="mini" @click="openEditDialog(row)">编辑</el-button>
                </template>
            </el-table-column>
        </jt-table>

        <div class="tar mt10">
            <el-pagination
                background
                layout="total, prev, pager, next, sizes"
                :total="total"
                :current-page="formData.page"
                :page-size="formData.page_size"
                :page-sizes="[20,50,100]"
                @current-change="handlePageChange"
                @size-change="handleSizeChange"
            />
        </div>

        <!-- 添加/编辑星级 弹框（同一套表单：集团名×媒体×包体×游戏类型 + 星级；有 id 即编辑单行） -->
        <el-dialog :title="starForm.id ? '编辑集团星级' : '添加星级'" :visible.sync="starDialog" width="480px" append-to-body>
            <el-form :model="starForm" label-width="80px">
                <el-form-item v-if="starForm.id" label="ID">
                    <span class="text-color-info">{{ starForm.id }}</span>
                </el-form-item>
                <el-form-item label="集团名称" required>
                    <el-input v-model="starForm.bloc_name" placeholder="填集团名称（须与工单集团名一致）" style="width:320px"/>
                </el-form-item>
                <el-form-item label="游戏类型" required>
                    <SelectAll :options="options.game_classify" v-model="starForm.game_classify" :multiple="false" placeholder="请选择"/>
                </el-form-item>
                <el-form-item label="包体类型" required>
                    <SelectAll :options="options.package_type" v-model="starForm.package_type" :multiple="false" placeholder="请选择"/>
                </el-form-item>
                <el-form-item label="媒体渠道" required>
                    <SelectAll :options="options.plat" v-model="starForm.plat_id" :multiple="false" placeholder="请选择"/>
                </el-form-item>
                <el-form-item label="星级" required>
                    <el-select v-model="starForm.star" placeholder="请选择" style="width:160px">
                        <el-option v-for="n in [0,1,2,3,4,5]" :key="n" :label="n+' 星'" :value="n"/>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="starDialog=false">取消</el-button>
                <el-button type="primary" :loading="starSaving" @click="handleStarSave">保存</el-button>
            </span>
        </el-dialog>

        <!-- 批量改星级 弹框（勾选维度行 → 统一改星级） -->
        <el-dialog title="批量改星级" :visible.sync="batchDialog" width="420px" append-to-body>
            <div class="tac">
                <p class="mb10">已选 <b class="text-color-primary">{{multipleSelection.length}}</b> 条维度记录，统一改为：</p>
                <el-select v-model="batchStar" placeholder="请选择星级" style="width:160px">
                    <el-option v-for="n in [0,1,2,3,4,5]" :key="n" :label="n+' 星'" :value="n"/>
                </el-select>
            </div>
            <span slot="footer">
                <el-button @click="batchDialog=false">取消</el-button>
                <el-button type="primary" @click="handleBatchSave">应用到选中</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import API from '@/api/workOrder/conf.js';
    import SelectAll from '@/components/SelectAll';

    export default {
        name: 'BlocStarList',
        components: { SelectAll },
        props: { pageFunc: Array },
        data() {
            return {
                dataLoading: false,
                dataList: [],
                total: 0,
                multipleSelection: [],
                batchStar: 0,
                batchDialog: false,
                importing: false,
                starDialog: false,
                starSaving: false,
                // id=0 添加 / id>0 单行编辑（同一套表单）
                starForm: { id: 0, bloc_name: '', game_classify: '', package_type: '', plat_id: '', star: 0 },
                options: { game_classify: [], package_type: [], plat: [], star: [] },
                formData: {
                    page: 1, page_size: 20,
                    search: '', id: '',
                    game_classify: '', package_type: '', plat_id: '',
                    star: '', star_sort: '',
                },
            };
        },
        computed: {
            pageFuncNames() {
                return (this.pageFunc || []).map(item => item.name);
            },
            // 添加星级 / 批量改星级 / 行内编辑 共用 edit_bloc_star（角色管理里叫「添加/编辑星级」）
            canEditStar() {
                return this.pageFuncNames.includes('edit_bloc_star');
            },
            // Excel 导入独立权限，与 canEditStar 互不依赖
            canImportStar() {
                return this.pageFuncNames.includes('import_bloc_star');
            },
            importUrl() {
                return '/td/api/work_order/bloc_star/import';
            },
        },
        mounted() {
            this.getSearchOptions();
            this.getList();
        },
        methods: {
            async getSearchOptions() {
                try {
                    const { data } = await API.getBlocStarSearchOptions();
                    this.options = {
                        game_classify: data.game_classify || [],
                        package_type: data.package_type || [],
                        plat: data.plat || [],
                        star: data.star || [],
                    };
                } catch (e) { /* ignore */ }
            },
            async getList() {
                try {
                    this.dataLoading = true;
                    const { data } = await API.getBlocStarList({ ...this.formData });
                    this.dataList = data.list || [];
                    this.total = data.total || 0;
                } catch (error) {
                    this.$message.error(error.info || '加载失败');
                } finally {
                    this.dataLoading = false;
                }
            },
            handleSearch() {
                this.formData.page = 1;
                this.getList();
            },
            handleReset() {
                this.formData = { page: 1, page_size: this.formData.page_size, search: '', id: '', game_classify: '', package_type: '', plat_id: '', star: '', star_sort: '' };
                this.getList();
            },
            handleSortChange({ prop, order }) {
                if (prop === 'star') {
                    this.formData.star_sort = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '');
                    this.formData.page = 1;
                    this.getList();
                }
            },
            handlePageChange(p) {
                this.formData.page = p;
                this.getList();
            },
            handleSizeChange(s) {
                this.formData.page_size = s;
                this.formData.page = 1;
                this.getList();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 手工添加维度组合星级
            openAddDialog() {
                this.starForm = { id: 0, bloc_name: '', game_classify: '', package_type: '', plat_id: '', star: 0 };
                this.starDialog = true;
            },
            // 单行编辑：回填当前行四维 + 星级（三维选项 id 是字符串，回填须 String 化才选得中）
            openEditDialog(row) {
                this.starForm = {
                    id: row.id,
                    bloc_name: row.bloc_name,
                    game_classify: String(row.game_classify),
                    package_type: String(row.package_type),
                    plat_id: String(row.plat_id),
                    star: Number(row.star),
                };
                this.starDialog = true;
            },
            async handleStarSave() {
                const f = this.starForm;
                if (!f.bloc_name || !f.bloc_name.trim()) { this.$message.warning('请填写集团名称'); return; }
                if (f.game_classify === '' || f.package_type === '' || f.plat_id === '') {
                    this.$message.warning('请选择游戏类型 / 包体类型 / 媒体渠道');
                    return;
                }
                this.starSaving = true;
                try {
                    if (f.id) {
                        // 编辑：四维 + 星级整体提交，后端合并后按 uk_dim 查冲突
                        await API.updateBlocStar({
                            id: f.id,
                            bloc_name: f.bloc_name.trim(),
                            plat_id: f.plat_id, package_type: f.package_type, game_classify: f.game_classify,
                            star: f.star,
                        });
                    } else {
                        const items = [{
                            bloc_name: f.bloc_name.trim(),
                            plat_id: f.plat_id, package_type: f.package_type, game_classify: f.game_classify,
                            star: f.star,
                        }];
                        await API.saveBlocStar({ items });
                    }
                    this.$message.success('保存成功');
                    this.starDialog = false;
                    this.getList();
                } catch (error) {
                    // 维度撞唯一键（code 40001）：$alert 点名冲突行 ID，弹框不关，让用户就地改
                    if (error && error.code === 40001) {
                        this.$alert(error.info || '与已有记录维度冲突', '维度冲突', { type: 'warning' });
                    } else {
                        this.$message.error((error && error.info) || '保存失败');
                    }
                } finally {
                    this.starSaving = false;
                }
            },
            openBatchDialog() {
                if (!this.multipleSelection.length) {
                    this.$message.warning('请先勾选记录');
                    return;
                }
                this.batchStar = 0;
                this.batchDialog = true;
            },
            // 批量改：保留每条选中行的维度，仅统一改星级
            async handleBatchSave() {
                if (!this.multipleSelection.length) {
                    this.$message.warning('请先勾选记录');
                    return;
                }
                const items = this.multipleSelection.map(row => ({
                    bloc_name: row.bloc_name,
                    plat_id: row.plat_id, package_type: row.package_type, game_classify: row.game_classify,
                    star: this.batchStar,
                }));
                try {
                    await API.saveBlocStar({ items });
                    this.$message.success('批量保存成功');
                    this.batchDialog = false;
                    this.getList();
                } catch (error) {
                    this.$message.error(error.info || '保存失败');
                }
            },
            // 导入前开 loading（防连点重复导入）
            handleBeforeImport() {
                this.importing = true;
                return true;
            },
            // 导入结果：用弹框展示（含未匹配渠道名报告），长文本 toast 装不下·成功失败都解除 loading
            handleImportSuccess(res) {
                this.importing = false;
                if (res && res.code === 200) {
                    this.$alert(res.info || '导入成功', '导入结果', { type: 'success', dangerouslyUseHTMLString: false });
                    this.getList();
                } else {
                    this.$alert((res && res.info) || '导入失败', '导入结果', { type: 'warning' });
                }
            },
            handleImportError() {
                this.importing = false;
                this.$message.error('导入失败');
            },
        },
    };
</script>

<style scoped>
    .filter-bar { margin-bottom: 6px; }
    .dib { display: inline-block; }
    .tar { text-align: right; }
    .tac { text-align: center; }
</style>
